import { render, staticRenderFns } from "./Armeria.vue?vue&type=template&id=3581b59e&scoped=true"
import script from "./Armeria.vue?vue&type=script&lang=js"
export * from "./Armeria.vue?vue&type=script&lang=js"
import style0 from "./Armeria.vue?vue&type=style&index=0&id=3581b59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581b59e",
  null
  
)

export default component.exports